import * as React from 'react';
import clsx from 'clsx';
import styles from './input-check.module.scss';
import { InputProps } from '@/interfaces';
import { ErrorMessageInput } from '@/components/common';

export const InputCheck: React.FC<
	InputProps &
		React.InputHTMLAttributes<HTMLInputElement> & { indeterminate?: boolean }
> = ({
	name,
	register,
	rules,
	error,
	children,
	className,
	classNameInput,
	classNameContainer,
	classNameLabel,
	checked,
	defaultChecked,
	onChangeCustom,
	indeterminate,
	...props
}) => {
	const inputRef = React.useRef<HTMLInputElement | null>(null);
	const registerAux = register(name, rules);
	const hasLabelText = children != null && children !== false;

	React.useEffect(() => {
		if (inputRef.current) {
			inputRef.current.indeterminate = !!indeterminate;
		}
	}, [indeterminate]);

	return (
		<div className="space-y-1">
			<label
				htmlFor={name}
				className={clsx(
					'relative flex items-center justify-start',
					{
						'text-status-disable': !defaultChecked,
						'w-full': hasLabelText,
						'cursor-not-allowed': props.disabled,
						'cursor-pointer': !props.disabled,
					},
					className,
					classNameContainer
				)}
			>
				<input
					className={clsx(styles.checkbox)}
					type="checkbox"
					id={name}
					name={name}
					checked={checked}
					defaultChecked={defaultChecked}
					{...props}
					ref={(el) => {
						if (registerAux && typeof registerAux.ref === 'function')
							registerAux.ref(el);
						inputRef.current = el;
					}}
					onBlur={(e) => {
						registerAux && registerAux.onBlur(e);
						props.onBlur && props.onBlur(e);
					}}
					onChange={(e) => {
						registerAux && registerAux.onChange(e);
						onChangeCustom && onChangeCustom(e);
						props.onChange && props.onChange(e);
					}}
				/>
				<span
					aria-hidden
					className={clsx(styles.box, 'size-6', classNameInput)}
				/>
				{hasLabelText && (
					<span
						className={clsx(
							'ml-2 text-black text-left text-sm font-normal min-w-0 flex-1',
							classNameLabel
						)}
					>
						{children}
					</span>
				)}
			</label>
			{error && error.message && <ErrorMessageInput message={error.message} />}
		</div>
	);
};
